const CTA_CONTAINER_SELECTOR = '[data-personalizer-italic-ctas="true"]';
const CTA_TEXT_SELECTOR = `${CTA_CONTAINER_SELECTOR} i, ${CTA_CONTAINER_SELECTOR} em`;
const CTA_CLASS = 'personalizer-richtext-cta';
const CTA_STYLE_CLASSES = ['button', 'button-secondary'];

let syncQueued = false;

function getPersonalizer(cta) {
  const container = cta.closest(CTA_CONTAINER_SELECTOR);
  const sectionId = container?.dataset.sectionId;
  const personalizers = Array.from(document.querySelectorAll('personalized-steps-popup-component'));

  if (sectionId) {
    return personalizers.find((personalizer) => personalizer.dataset.sectionId === sectionId) || personalizers[0] || null;
  }

  return personalizers[0] || null;
}

function getStyleClass(cta) {
  const container = cta.closest(CTA_CONTAINER_SELECTOR);
  return container?.dataset.personalizerItalicCtaStyle === 'button-secondary' ? 'button-secondary' : 'button';
}

function safeCapturePostHogEvent(eventName, properties) {
  try {
    window.posthog?.capture?.(eventName, properties);
  } catch (error) {
    // Analytics must never block opening the personalizer.
  }
}

function trackSecondaryOpen(cta, personalizer, triggerType) {
  const container = cta.closest(CTA_CONTAINER_SELECTOR);

  safeCapturePostHogEvent('personalized_steps_secondary_open', {
    source: 'personalizer-richtext-cta',
    path_version: 'personalized_steps_v1',
    trigger_type: triggerType,
    cta_text: cta.textContent?.trim() || undefined,
    cta_style: getStyleClass(cta),
    section_id: container?.dataset.sectionId || personalizer.dataset.sectionId || undefined,
    personalizer_block_id: personalizer.dataset.blockId || undefined,
    product_handle: personalizer.dataset.productHandle || undefined,
  });
}

function resetCta(cta) {
  cta.classList.remove(CTA_CLASS, ...CTA_STYLE_CLASSES);
  cta.removeAttribute('data-personalizer-richtext-cta');
  cta.removeAttribute('role');
  cta.removeAttribute('tabindex');
  cta.removeAttribute('aria-label');
}

function upgradeCta(cta) {
  const label = cta.textContent?.trim();
  const personalizer = getPersonalizer(cta);

  if (!label || cta.closest('a, button') || typeof personalizer?.openPopup !== 'function') {
    resetCta(cta);
    return;
  }

  cta.classList.remove(...CTA_STYLE_CLASSES);
  cta.classList.add(CTA_CLASS, getStyleClass(cta));
  cta.setAttribute('data-personalizer-richtext-cta', '');
  cta.setAttribute('role', 'button');
  cta.setAttribute('tabindex', '0');
  cta.setAttribute('aria-label', label);
}

function syncCtas() {
  document.querySelectorAll(CTA_TEXT_SELECTOR).forEach(upgradeCta);
}

function scheduleSync() {
  if (syncQueued) return;
  syncQueued = true;

  const sync = () => {
    syncQueued = false;
    syncCtas();
  };

  if (typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(sync);
  } else {
    window.setTimeout(sync, 0);
  }
}

function openCtaPersonalizer(event) {
  const target = event.target instanceof Element ? event.target : event.target?.parentElement;
  const cta = target?.closest?.(`.${CTA_CLASS}`);
  if (!cta) return;

  const personalizer = getPersonalizer(cta);
  if (typeof personalizer?.openPopup !== 'function') return;

  event.preventDefault();
  event.stopPropagation();
  trackSecondaryOpen(cta, personalizer, event.type);
  personalizer.openPopup();
}

if (!window.__personalizerRichTextCtasInitialized) {
  window.__personalizerRichTextCtasInitialized = true;

  document.addEventListener('click', openCtaPersonalizer);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    openCtaPersonalizer(event);
  });

  new MutationObserver(scheduleSync).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-personalizer-italic-ctas', 'data-personalizer-italic-cta-style'],
  });
}

scheduleSync();
customElements.whenDefined('personalized-steps-popup-component').then(scheduleSync);
